import React, { useState } from 'react';

import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const EPCIs = ["Toutes","Communauté d'agglomération Ardenne Métropole","Communauté de communes Ardenne, Rives de Meuse","Communauté de communes Ardennes Thiérache","Communauté de communes des Portes du Luxembourg","Communauté de communes Vallées et Plateau d'Ardenne"];


const EPCISelection = (props) => {
    const {EPCI, setEPCI} = props;

    const handleChange = (event) => {
        setEPCI(event.target.value);
    };

    return (
        <Box sx={{ width: "100%", backgroundColor: "white" }}>
            <FormControl sx={{width: "100%"}}>
                <InputLabel id="demo-simple-select-label">EPCI</InputLabel>
                <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={EPCI}
                label="EPCI"
                onChange={handleChange}
                >
                {EPCIs.map(epci => (
                    <MenuItem value={epci}>{epci}</MenuItem>
                ))}
                </Select>
            </FormControl>
        </Box>
    )
}

export default EPCISelection